app.controller('teacherAppGroupStatusDetailsCtrl', [
    '$scope', '$interval', 'gameService', 'teacherAppService', '$state', '$stateParams', '$window', '$timeout', function ($scope, $interval, gameService, teacherAppService, $state, $stateParams, $window, $timeout) {
    	var vm = this;

    	vm.gameService = gameService;
        vm.teacherAppService = teacherAppService;

		vm.gameInverseProgressStyle = [];
		vm.gameProgress = [];
		vm.gameExercisePercentages = [];
		vm.gameExerciseListStyle = [];

		vm.exercises = [];
		vm.filterExercises = function() {
			var gameState = vm.teacherAppService.gameInfo[vm.teacherAppService.currentGroup].gameState;
			var game = vm.teacherAppService.gameInfo[vm.teacherAppService.currentGroup].game;
			for (var i = 0; i < game.exercises.length; i++) {
				var exercise = angular.copy(game.exercises[i]);
				exercise.index = i;
				if (i < gameState.exerciseIndex) {
					continue;
				}
				vm.exercises.push(exercise);
			}
		}
		vm.filterExercises();

		vm.showDetails = function(idx) {
			vm.teacherAppService.setCurrentGroup(idx);
			$state.go('teacherapp.groupstatus.details', {id: idx});
		}

        vm.switchGroup = function(idx) {
        	vm.teacherAppService.setCurrentGroup(idx);
	        $state.go('.', {id: idx});
        }

        vm.groupPickerElement = angular.element(".tagrouppicker")[0];
        if (vm.groupPickerElement) {
	        vm.groupPickerElement.addEventListener("scroll", function() {
	        	vm.teacherAppService.groupPickerScrollOffset = vm.groupPickerElement.scrollLeft;
	        });
	        $timeout(function() {
	    		vm.groupPickerElement.scrollLeft = vm.teacherAppService.groupPickerScrollOffset;
	    	});
	   	}

        vm.goMap = function() {
        	$state.go('teacherapp.groupstatus.detailsmap', {id: vm.teacherAppService.currentGroup}, {reload: true});
        }

        vm.goBack = function() {
        	$state.go('teacherapp.groupstatus');
        }

        vm.goExercise = function(idx) {
        	var gameState = vm.teacherAppService.gameInfo[vm.teacherAppService.currentGroup].gameState;
			var game = vm.teacherAppService.gameInfo[vm.teacherAppService.currentGroup].game;
			
			vm.gameService.setTeacherAppState(game, gameState);

			var exercise = game.exercises[idx];

			if (gameState.exerciseIndex == idx) {
				if (exercise.questions.length === gameState.questionIndex) {
					$state.go('teacherapp.exerciseevalperform', {id: gameState.exerciseIndex, question: gameState.evaluationQuestionIndex});
				} else {
					$state.go('teacherapp.exerciseperform', {id: gameState.exerciseIndex, question: gameState.questionIndex});
				}
			} else {
				$state.go('teacherapp.exercisepeform', {id: idx, qeustion: 0});
			}
		}

		function countGameStateProgress(gameInfo) {
			var gameState = gameInfo.gameState;
			var game = gameInfo.game;

			var count = 0;
			for (var i = 0; i < game.exercises.length; i++) {
				if (i == gameState.exerciseIndex) {
					count += gameState.questionIndex;
					count += gameState.evaluationQuestionIndex;
					return count;
				}
				var exercise = game.exercises[i];
				count += exercise.questions.length;
				count += exercise.evaluationQuestions.length;
			}
			return count;
		}

		function countTotalItemsForGameInfo(gameInfo) {
			var game = gameInfo.game;
			var totalItems = 0;
			for (var i = 0; i < game.exercises.length; i++) {
				var exercise = game.exercises[i];

				var nitems = 0;
				nitems += exercise.questions.length;
				nitems += exercise.evaluationQuestions.length;

				totalItems += nitems;
			}
			return totalItems;
		}

		function itemsPerExerciseForGameInfo(gameInfo) {
			var game = gameInfo.game;
			var itemsPerExercise = [];
			for (var i = 0; i < game.exercises.length; i++) {
				var exercise = game.exercises[i];

				var nitems = 0;
				nitems += exercise.questions.length;
				nitems += exercise.evaluationQuestions.length;
				itemsPerExercise.push(nitems);
			}
			return itemsPerExercise;
		}

		function percentagePerExerciseForGameInfo(gameInfo) {
			var itemsPerExercise = itemsPerExerciseForGameInfo(gameInfo);

			var totalItems = 0;
			for (var i = 0; i < itemsPerExercise.length; i++) {
				totalItems += itemsPerExercise[i];
			}

			var percentagePerExercise = [];
			for (var i = 0; i < itemsPerExercise.length; i++) {
				percentagePerExercise.push(itemsPerExercise[i] / totalItems);
			}

			return percentagePerExercise;
		}

		vm.updateStateFromTeacherAppService = function() {
			if (!teacherAppService.isReady()) {
				return;
			}
			vm.gameInverseProgressStyle = [];
			vm.gameProgress = [];
			vm.gameExercisePercentages = [];
			vm.gameExerciseListStyle = [];
			var gameInfo = vm.teacherAppService.gameInfo;
			for (var i = 0; i < gameInfo.length; i++) {
				var gi = gameInfo[i];
				var totalItems = countTotalItemsForGameInfo(gi);
				var progress = countGameStateProgress(gi);
				var pct = progress / totalItems;
				var gameExercisePercentage = percentagePerExerciseForGameInfo(gi);
				vm.gameInverseProgressStyle.push({"width": (100 - parseInt(pct * 100)) + "%"});
				vm.gameProgress.push(parseInt(pct * 100));

				vm.gameExercisePercentages.push(gameExercisePercentage);

				var styles = [];
				for (var j = 0; j < gameExercisePercentage.length; j++) {
					var exercisePercentage = gameExercisePercentage[j];
					var style = { "flex": "" + exercisePercentage, "msFlex": "" + exercisePercentage };
					styles.push(style);
				}

				vm.gameExerciseListStyle.push(styles);
			}
		}

        $scope.$on('teacherAppServiceUpdated', function() {
        	vm.updateStateFromTeacherAppService();
        });

        vm.updateStateFromTeacherAppService();

        // ---- MAP ----

        if ($window.location.href.indexOf("detailsmap") !== -1) {
        	$timeout(function() {
				vm.curPos = [0.0, 0.0];

		    	vm.map = new maptalks.Map('maptalksc', {
		        	center: vm.gameService.config.mapCenter,
		        	zoom: 16.64,
		        	bearing: 150.0,
		        	attribution: false,

			        //allow map to drag pitching, true by default
		        	dragPitch : false,
		        	//allow map to drag rotating, true by default
		        	dragRotate : true,
		        	//enable map to drag pitching and rotating at the same time, false by default
		        	dragRotatePitch : false,

		        	baseLayer: new maptalks.TileLayer('base', {
		          		urlTemplate: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
		          		subdomains: ['a','b','c','d'],
		          		attribution: ''
		        	})
		      	});

				var center = vm.map.getCenter();
				var layer = new maptalks.VectorLayer('vector').addTo(vm.map);

				vm.rideMarkers = {};
		        for (var i = 0; i < vm.gameService.rides.length; i++) {
		            var ride = vm.gameService.rides[i];

		            if (ride.enabled) {
		                var marker = new maptalks.Marker(ride.location, {
		                    'symbol' : {
		                        'markerFile'   : ride.markerImage,
		                        'markerWidth'  : ride.markerWidth,
		                        'markerHeight' : ride.markerHeight,
		                        'markerDx'     : 0,
		                        'markerDy'     : 0,
		                        'markerOpacity': 1
		                    }
		                });
		                vm.rideMarkers[ride.key] = marker;
		                marker.addTo(layer);
		            }
		        }

		        vm.gameMarker = undefined;
		        vm.createGameMarker = function() {
		        	if (vm.gameMarker) {
		        		return;
		        	}
		        	var gameInfos = vm.teacherAppService.gameInfo;
		        	var i = $stateParams.id;
	                var gameInfo = gameInfos[i];
	                var marker = new maptalks.Marker(gameInfo.locationState.lastLocation, {
	                    'symbol' : {
	                        'markerFile'   : window.location.origin + '/img/map/MapPin' + (i + 1) + '.svg',
	                        'markerWidth'  : 2*22,
	                        'markerHeight' : 2*35.5,
	                        'markerDx'     : 0,
	                        'markerDy'     : 0,
	                        'markerOpacity': 1
	                    }
	                });
	                marker.addTo(layer);
	                vm.gameMarker = marker;
		        }

		        vm.updateMarkerLocations = function() {
		            vm.createGameMarker();

		            var gameInfos = vm.teacherAppService.gameInfo;
		            var i = $stateParams.id;
	                var gameInfo = gameInfos[i];
	                var teamNumber = i + 1;
	                var marker = vm.gameMarkers[i];
	                marker.setCoordinates(gameInfo.locationState.lastLocation);
		        }

		        $scope.$on('teacherAppServiceUpdated', function(gameInfo) {
		            vm.updateMarkerLocations();
		        });
			});
        }
    }
]);